/**
 * Whether a LiveKit room.connect failure means the JWT was refused (remint path).
 */
export function isRefusedLiveKitToken(error: unknown): boolean {
  if (!error || typeof error !== 'object') {
    return false;
  }
  const err = error as Error & { status?: number };
  if (err.status === 401) {
    return true;
  }
  const message = err.message?.toLowerCase() ?? '';
  return message.includes('invalid token') || message.includes('revoked');
}
